<template>
  <v-container >
    <v-row>
      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการอัลบั้มชุดภาพประกอบ</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + web_con_new_images.length }} รายการ) </span>
            <v-spacer></v-spacer>

          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="web_con_new_images"
                :items-per-page="15"
                sort-by="order_seq">
              <template v-slot:top>


                <template>

                  <v-form
                      ref="form"
                      v-model="editForm.valid"
                      lazy-validation>

                    <div>
                      <v-file-input
                          @change="inputChanged"
                          v-model="files"
                          small-chips
                          show-size
                          multiple
                          clearable
                          :rules="editForm.imageRules"
                          accept="image/*"
                          placeholder="คลิกที่นี่!! สามารถเพิ่มรูปภาพ ได้ครั้งละ 20 ภาพ"
                          label="คลิกที่นี่!! สามารถเพิ่มรูปภาพ ได้ครั้งละ 20 ภาพ (การคลิกอีกครั้งจะเป็นการเปลี่ยนข้อมูล)"

                      >
                        <template v-slot:selection="{ text, index/*, file*/ }">
                          <v-chip

                              text-color="white"
                              color="#295671"
                              close
                              @click:close="remove(index)"
                          >
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                    </div>

                    <p>
                      **สามารถเพิ่มรูปภาพ ได้ครั้งละ 20 ภาพ **หากมีภาพประกอบมากกว่า 20 ภาพ กรุณาบันทึกแล้วเพิ่มอีกครั้ง </p>

                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                     บันทึก/upload
                    </v-btn>



                  </v-form>



                </template>



              </template>

              <template v-slot:item.order_seq="{ item }">

               {{item.news_image_id}}

              </template>


              <template v-slot:item.news_image_id="{ item }">

                <v-avatar tile >
                  <img
                      :src="baseURLStorage+item.news_b_image"
                  >
                </v-avatar>

              </template>

              <template v-slot:item.news_b_image="{ item }">


                <v-text-field
                    :label="baseURLStorage"
                    :value="item.news_b_image"
                    :append-outer-icon="'mdi-content-copy'"
                    type="text"
                    @click:append-outer="copyToClipBoard(baseURLStorage+item.news_b_image)"
                ></v-text-field>


              </template>





<!--              <template v-slot:item.order_seq="{ item }">-->
<!--                <span>{{ item.order_seq }}</span>-->

<!--              </template>-->




              <template v-slot:item.api="{ item }">
<!--                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>-->
                <v-btn
                    class="mr-3 button-shadow"
                    @click="copyToClipBoard(baseURLStorage+item.news_b_image)"
                    small
                    color="success"
                >คัดลอก
                </v-btn>

                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
        v-model="snackbar_copy"
        :timeout="2000"
    >
      <div v-html="text" class=""></div>

      <template v-slot:action="{ attrs }">
        <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import axios from "axios";


export default {
  name: 'EduLevelManagement',
  data() {
    return {
      state: 'index',
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      snackbar_copy: null,
      search: '',
      selected: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'order_seq',
        },
        {
          text: 'รูปภาพ',
          value: 'news_image_id',
        },
        {text: 'URL(ที่อยู่ของไฟล์)', value: 'news_b_image'},
        // {text: 'ลำดับ', value: 'order_seq'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ['news_image_id'],
        sortDesc: [true]
      },

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        textReqRules: validateRules.textReqRules,
        numRules: validateRules.numRules,
        imageRules: validateRules.fileMultiReqRules(25),
        multipleReqRules: validateRules.multipleReqRules,
      },

      files: []
    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_new_images', ['news_id','web_con_new_images', "isReceiving", "isDeleting", "idToDelete", "pageMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },

  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    pageMessage() {

      if (this.pageMessage !== '') {
        this.notification = this.pageMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWeb_con_new_imagesRequest(this.news_id);


  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_new_images',
        [
          "getWeb_con_new_imagesRequest",
          "deleteWeb_con_new_imageRequest",
          "updateWeb_con_new_imageRequest",
          "createWeb_con_new_imageRequest"
        ]
    ),
    remove (index) {
      this.files.splice(index, 1)
    },
    inputChanged () {
      // console.log(this.files)
    },
    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.editForm.news_image_id = null;
      this.editForm.news_id = this.news_id.news_id;

      this.state = 'addForm';

    },
    editItem(item) {
      this.editedIndex = this.web_con_new_images.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.news_image_id = item.news_image_id;
      this.editForm.news_id = item.news_id;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWeb_con_new_imageRequest({news_image_id: item.news_image_id})


    },
    close() {

      if (this.errorMessage == false || this.pageMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {

      this.editForm.fileAll = this.files;

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.web_con_new_images[this.editedIndex], this.editForm)
            :
            // this.updateWeb_con_new_imageRequest(this.editForm)
        this.save_axios();
      } else {
        !config.isBackend ?
            this.web_con_new_images.push(this.editForm)
            :
            // this.createWeb_con_new_imageRequest(this.editForm)
            this.save_axios();
      }

    },

    async save_axios() {

      try {

        let formData = new FormData()
        for (const [i, file]  of (this.editForm.fileAll).entries()) {
          formData.append('file'+i, file)
        }
        formData.append('file_length', this.editForm.fileAll.length);
        formData.append('news_id', this.news_id.news_id);

        await axios.post(config.baseURLApi + '/web_con_new_images', formData, {
          headers: {},
        }).then(res => {

          this.getWeb_con_new_imagesRequest(this.news_id);
          this.snackbar = true;
          this.color = config.light.success;
          this.text = 'บันทึกสำเร็จ!  ' + res.data.length + ' รายการ ถูกบันทึกแล้ว';

          this.files=[];

        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },

    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },

    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },

    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    copyToClipBoard(textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      this.snackbar_copy = true;
      this.color = config.light.secondary;
      this.text = "คัดลอก " + textToCopy;

    },


  },
}
</script>

<style src="./ConNewImageManagement.scss" lang="scss"/>
